import React from 'react';
import "./BentoGridModal.css";
import { Modal, Slide, Grow } from '@mui/material';
import { X } from 'lucide-react';
import { useIsMobile } from '../../../../custom-hooks/useIsMobile';



interface CardData {
    title: string;
    subtitle: string;
    buttonOne: string;
    buttonTwo: string;
    points: string[];
    insideComponent: React.ReactNode;
}

const BentoGridModal = ({ open, onClose, cardData }: { readonly open: boolean, readonly onClose: () => void, readonly cardData: CardData }) => {

    const isMobile: boolean = useIsMobile();
    
    return (
        <Modal open={open} onClose={onClose} disableScrollLock sx={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'center' }}>
            <Slide timeout={{ enter: 350, exit: 200 }} direction="up" in={open} mountOnEnter unmountOnExit>
                <div className={isMobile ? "bento-grid-modal-mobile" : "bento-grid-modal"}>
                    <button className="bento-grid-modal-close" onClick={onClose}><X size={20} /></button>

                    <div className={isMobile ? "bento-grid-modal-content-top-mobile" : "bento-grid-modal-content-top"}>

                        <div className="bento-grid-modal-content-top-left">
                            <div className="bento-grid-modal-title">{cardData.title}</div>
                            <div className="bento-grid-modal-description">{cardData.subtitle}</div>
                            
                            <div className="bento-grid-modal-buttons">
                                <button className="bento-grid-modal-button-one">{cardData.buttonOne}</button>
                                <button className="bento-grid-modal-button-two">{cardData.buttonTwo}</button>
                            </div>
                        </div>

                        <div className="bento-grid-modal-content-top-right">
                            <div className="bento-grid-modal-points">
                                {cardData.points.map((point: string, index: number) => (
                                    <div key={index} className="bento-grid-modal-point-item">{point}</div>
                                ))}
                            </div>
                        </div>

                    </div>

                    <div className="bento-grid-modal-content-bottom">
                        <div className="bento-grid-modal-inside-component">{cardData.insideComponent}</div>
                    </div>

                </div>
            </Slide>
        </Modal>
    );
};

export { BentoGridModal, CardData };